module.exports = __webpack_public_path__ + "media/images/ohap_email_header-f7ea508b6500d1f725c0c1672bac66bd.png";